"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'file.clipboard.images_pasted': '{count} imagen(es) pegada(s) desde el portapapeles',
};
